export default __webpack_public_path__ + "static/media/hos-bg-2.007b222c.png";